import _ from 'lodash';
import NBAActionCreator from '../../actions/NBAActionCreator';
import NBAInsightEntity from '../../entities/nba/NBAInsightEntity';
import StringConstants from '../../constants/StringConstants';
import NBAStore from '../../stores/NBAStore';
import NBAPayload from '../nba/NBAPayload';
import envConfig from '../../../static/config';
import NBAApiUtils from '../../utils/NBAApiUtils';
import AnalyticsActionCreator from '../../actions/AnalyticsActionCreator';
import AnalyticsUtil from '../../utils/AnalyticsUtil';
import config from '../../config/index';
import NBAParser from '../../parsers/NbaParser';
import AccountsActionCreator from '../../actions/AccountsActionCreator';
import AccountsStore from '../../stores/AccountsStore';

import AppStore from '../../stores/AppStore';
import InternetBankingActions from '../../actions/InternetBankingActions';
import SessionStore from '../../stores/SessionStore';

class NBABL {
  addNBAOnPosition(accountList, position, component) {
    if (_.has(component, 'props.data') && component.props.data) {
      if (accountList.length <= position - 1) {
        accountList.push(component);
      } else {
        accountList.splice(position - 1, 0, component);
      }
    }
  }
  getBannerComponent(component) {
    if (_.has(component, 'props.data') && component.props.data) {
      return component;
    }
    return null;
  }
  getProductBannerComponent(component, bankid, fallBack) {
    if (bankid === 'DYB') {
      if (typeof fallBack === 'function') {
        return fallBack();
      }
    } else {
      const comp = this.getBannerComponent(component);
      if (comp) {
        return comp;
      } else {
        return fallBack();
      }
    }
  }
  isSplashEnabled(userSetings, nbadata) {
    const splash = nbadata.getSplash();
    if (userSetings.isSplashEnabled() && !userSetings.isSplashAcknowledged()) {
      if (splash && splash[0].isTextContent) {
        return true;
      } else {
        if (!this.isCalled) {
          this.isCalled = true;
          this.callAccountService();
        }
        return false;
      }
    } else {
      return false;
    }
  }
  isPopupHasCrossIcon(userSetings, nbadata, nbaAction) {
    return !(
      this.isSplashEnabled(userSetings, nbadata) && _.isEmpty(nbaAction)
    );
  }
  getSplashData(nbadata) {
    let splash = nbadata.getSplash();
    if (splash) {
      splash = splash[0];
      if (splash.isTextContent) {
        if (splash.textValue) {
          NBAStore.setParsedSplashData(splash);
          return splash;
        } else if (splash.textStaticUrl) {
          if (this.endsWith(splash.textStaticUrl, '.html')) {
            splash.textHeader = '';
            splash.textValue = this.getSplashHtml(splash.textStaticUrl);
          } else if (this.endsWith(splash.textStaticUrl, '.json')) {
            const jsonData = this.readResourceContent(
              splash.textStaticUrl,
              's_type'
            );
            if (jsonData) {
              splash.textHeader = jsonData.textHeader;
              splash.textValue = jsonData;
              splash.textInstruction = jsonData.textInstruction;
            }
          }
          NBAStore.setParsedSplashData(splash);
          return splash;
        } else {
          return new NBAInsightEntity();
        }
      }
    }
  }
  endsWith(str, suffix) {
    return (
      str
        .toUpperCase()
        .indexOf(suffix.toUpperCase(), str.length - suffix.length) !== -1
    );
  }
  callNBAServices(userSetings) {
    if (userSetings.isInsightEnable()) {
      NBAActionCreator.requestNBAData(StringConstants.ACCTSUMM);
    }
    if (userSetings.isSplashEnabled() && !userSetings.isSplashAcknowledged()) {
      NBAActionCreator.requestSplashData();
    }
    if (
      (userSetings.isSplashEnabled() && userSetings.isSplashAcknowledged()) ||
      !userSetings.isSplashEnabled()
    ) {
      this.callAccountService();
    }
  }
  callAccountService() {
    if (AccountsStore.getAll().length === 0) {
      AccountsActionCreator.getAccountsList();
    }
  }
  toMarketingPreference() {
    if (!SessionStore.getAll().authenticated) {
      InternetBankingActions.navigateToWebTask(
        'WEB-INVALIDTOKENSESSIONTIMEOUT'
      );
      return;
    }
    SessionStore.setTokenDelete(false); // Not to delete token while navigating to marketing preference page
    const accessToken =
      SessionStore.getURLTokenValue() ||
      SessionStore.getToken()['access_token'];

    let redirectToBOW = envConfig.redirectToBOW;
    redirectToBOW = redirectToBOW.replace('{access_token}', accessToken);

    let marketingPreferenceLink = envConfig.marketingPreferenceLink;
    marketingPreferenceLink = marketingPreferenceLink.replace(
      '{bank_id}',
      SessionStore.getSessionBankID()
    );
    marketingPreferenceLink = marketingPreferenceLink.replace(
      '{access_token}',
      accessToken
    );
    marketingPreferenceLink = marketingPreferenceLink.replace(
      '{redirect_uri}',
      encodeURIComponent(redirectToBOW)
    );
    marketingPreferenceLink = marketingPreferenceLink.replace(
      '{user_tracking_id}',
      AppStore.getUserTrackingID()
    );
    return marketingPreferenceLink;
  }
  getSplashHtml(path) {
    const doc = document.implementation.createHTMLDocument('nba');
    if (path && path.indexOf('http://') === -1) {
      const fullPath = this.getCompletePath(path, 's_type');
      const responseText = NBAApiUtils.getResource(fullPath);
      doc.documentElement.innerHTML = responseText;
    }
    return doc.body.innerHTML;
  }
  readResourceContent(path, type) {
    let response = undefined;
    const fullPath = this.getCompletePath(path, type);
    const responseText = NBAApiUtils.getResource(fullPath);
    if (this.isHtml(responseText)) {
      response = NBAParser.getHtmlFileObject(responseText);
    } else {
      const jsonObj = this.isJson(responseText);
      if (jsonObj) {
        response = NBAParser.getJSONFileObject(jsonObj);
      }
    }
    return response;
  }
  isJson(str) {
    let jsonObj = undefined;
    try {
      jsonObj = JSON.parse(str);
    } catch (e) {
      jsonObj = undefined;
    }
    return jsonObj;
  }
  isHtml(str) {
    const text = String(str);
    if (
      text.indexOf('<h1') !== -1 ||
      text.indexOf('<h2') !== -1 ||
      text.indexOf('<p') !== -1
    ) {
      return true;
    } else {
      return false;
    }
  }
  getCompletePath(path, type) {
    let container = 'nba';
    if (type === 's_type') {
      container = 'splash';
    }
    if (
      path &&
      path.indexOf('http://') === -1 &&
      path.indexOf('https://') === -1
    ) {
      const prefix = `${window.bowBaseUrl}/static/${String(
        envConfig.brandId
      ).toLowerCase()}/${container}`;
      return prefix + path;
    } else {
      return path;
    }
  }
  getAnalyticsData(nbaAction, behaviour) {
    if (nbaAction.containerId === 'S1') {
      return {
        dataContext: `/banks/${envConfig.brandId}/splash`,
        behaviour,
        offerId: nbaAction.offerId,
      };
    } else {
      return {
        dataContext: StringConstants.ACCTSUMM,
        behaviour,
        offerId: nbaAction.offerId,
        container: nbaAction.containerId,
      };
    }
  }
  sendUserFeedBackHomePage(nbaAction, behaviour) {
    this.sendUserFeedBack(StringConstants.ACCTSUMM, nbaAction, behaviour);
  }
  sendUserFeedBackProduct(nbaAction, behaviour) {
    this.sendUserFeedBack(StringConstants.PRODUCTPAGE, nbaAction, behaviour);
  }
  sendUserFeedBack(source, nbaAction, behaviour) {
    const payload = NBAPayload.nbaContainerUserInteraction(
      nbaAction.id,
      nbaAction.offerId,
      behaviour
    );
    NBAActionCreator.sendNBAContainerAcknowledgement(source, payload);
    AnalyticsUtil.analyticAction(
      config.analytics.analytics_experience_activity,
      config.analytics.analytics_event_method_cta,
      this.getAnalyticsData(nbaAction, behaviour)
    );
    AnalyticsActionCreator.requestImmediateDispatch();
  }
  getButtonText(insight) {
    return insight.textInstruction ? insight.textInstruction : 'Find out more';
  }
}

export default new NBABL();
